export const ZITADEL_BASE_URL = process.env.ZITADEL_URL || '';
export const ZITADEL_CALLBACK_ROUTE_URL = 'zitadel';
